import { AssigneeInfoByProcInstIdParameter } from './complete-response';

/**
 * 提交审批客户端交互返回结果
 */
export class InteractionResponse {
    /**
     * 提交选择流程场景下返回流程定义Id
     */
    processDefinitionId: string;
    /**
     * 提交审批指定参与者时返回参数
     */
    assigneeInfoParameter: AssigneeInfoByProcInstIdParameter;
    /**
     * 交互异常提示信息
     */
    message: string;
}
